// extracted by mini-css-extract-plugin
export var actionRow = "_mv-6";
export var card = "_mv-0";
export var chevron = "_mv-5";
export var content = "_mv-2";
export var details = "_mv-3";
export var eventActionToggle = "_mv-4";
export var icon = "_mv-1";
export var iconBlue = "_mv-8";
export var iconBrand = "_mv-7";
export var iconGrayBlue = "_mv-9";
export var iconGreen = "_mv-a";
export var iconIndigo = "_mv-b";
export var iconOrange = "_mv-c";
export var iconPurple = "_mv-d";
export var iconRed = "_mv-e";
export var iconWarning = "_mv-f";